

export default class DynamicControlHelpers {
    static dynamicControlTypes() {   
        const types = [
            {value: 'tf', text: 'Text Field', control: 'v-text-field'},
            {value: 'ta', text: 'Text Area', control: 'v-textarea'},
            {value: 'ls', text: 'Dropdown List', control: 'v-select'},
            
        ]
        
        return types
    }
}


// WEBPACK FOOTER //
// ./src/helpers/DynamicControlHelpers.js